import { Link } from 'react-router-dom';
import { resourceComparison } from '@/mocks/siteData';

export default function ComparisonSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-800 text-xs font-semibold mb-4 whitespace-nowrap">
            Quick Comparison
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Sugargoo Shopping Resources Comparison
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto text-sm leading-relaxed">
            Not sure where to start? Use this quick comparison to find the right resource for your needs.
          </p>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/60 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-background-200/60">
                  <th className="text-left px-6 py-4 font-semibold text-foreground-700 whitespace-nowrap">Resource</th>
                  <th className="text-left px-6 py-4 font-semibold text-foreground-700 whitespace-nowrap">Best For</th>
                  <th className="text-left px-6 py-4 font-semibold text-foreground-700 whitespace-nowrap">Difficulty</th>
                  <th className="text-left px-6 py-4 font-semibold text-foreground-700 whitespace-nowrap">Updated</th>
                </tr>
              </thead>
              <tbody>
                {resourceComparison.map((row, idx) => (
                  <tr key={idx} className="border-b border-background-200/40 last:border-b-0 hover:bg-background-200/30 transition-colors">
                    <td className="px-6 py-4 font-medium text-foreground-800 whitespace-nowrap">{row.resource}</td>
                    <td className="px-6 py-4 text-foreground-600">{row.bestFor}</td>
                    <td className="px-6 py-4">
                      <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
                        row.difficulty === 'Easy' ? 'bg-secondary-100 text-secondary-800' : 'bg-accent-100 text-accent-800'
                      }`}>
                        {row.difficulty}
                      </span>
                    </td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center gap-1.5 text-foreground-600">
                        <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
                        {row.updated}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="text-center mt-8">
          <Link
            to="/article/sugargoo-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 font-medium rounded-lg border border-background-200/60 hover:border-primary-300 hover:text-primary-700 transition-all duration-300 text-sm whitespace-nowrap cursor-pointer"
          >
            View Full Comparison Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}